import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";

const STATIC = {
  shipping: { title: "Shipping", body: "All Maison Évaren orders ship from Milton / Mississauga, Ontario, Canada via Stallion Express. We ship worldwide. Complimentary standard shipping applies to orders over $500. Duties and import taxes for international destinations are estimated and, where possible, collected upfront at checkout so there are no surprises on delivery." },
  returns: { title: "Returns", body: "We accept returns within 30 days of delivery on unworn items in their original condition and packaging. Fine jewelry and made-to-order pieces may be subject to specific conditions. Please contact customer care to initiate a return." },
  faqs: { title: "Frequently Asked Questions", body: "For questions regarding orders, sizing, materials, shipping and returns, please reach our customer care team. We respond within one business day." },
  contact: { title: "Contact", body: "Maison Évaren customer care — support@maisonevaren.com. Our atelier is based in Ontario, Canada. We are an online-only maison." },
  privacy: { title: "Privacy Policy", body: "Maison Évaren respects your privacy. We collect only the information necessary to fulfil your orders and enhance your experience. Your data is never sold." },
  terms: { title: "Terms & Conditions", body: "By using this website you agree to our terms of service. All prices are subject to change. Maison Évaren reserves all rights to its designs and content." },
};

export default function StaticPage() {
  const { slug } = useParams();
  const { storefront } = useApp();
  const [content, setContent] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/storefront/${storefront}/bootstrap`).then((r) => setContent(r.data.content || {})).catch(() => {});
  }, [storefront]);

  if (slug === "about") {
    return (
      <div>
        {content.about_image && (
          <section className="relative h-[55vh] min-h-[380px] img-zoom">
            <img src={content.about_image} alt="" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/35 flex items-center justify-center">
              <h1 className="font-serif italic text-white text-5xl md:text-7xl">{content.about_title || "The Maison"}</h1>
            </div>
          </section>
        )}
        <div className="max-w-2xl mx-auto px-6 py-20 text-center">
          <p className="font-serif text-2xl md:text-3xl leading-relaxed">{content.about_body}</p>
        </div>
      </div>
    );
  }

  const page = STATIC[slug] || { title: "Maison Évaren", body: "Content coming soon." };
  return (
    <div className="max-w-2xl mx-auto px-6 py-24 min-h-[50vh]">
      <h1 className="font-serif text-4xl md:text-5xl mb-8">{page.title}</h1>
      <p className="text-base leading-relaxed" style={{ color: "var(--ev-muted)" }}>{page.body}</p>
    </div>
  );
}
